export const transactionQueryKeys = {
  all: ['transactions'] as const,
  recent: () => [...transactionQueryKeys.all, 'recent'] as const,
  list: (params?: object) => [...transactionQueryKeys.all, 'list', params] as const,
  userList: () => [...transactionQueryKeys.all, 'user-list'] as const,
  detail: (id: string) => [...transactionQueryKeys.all, 'detail', id] as const,
  hasUnattributed: () => [...transactionQueryKeys.all, 'has-unattributed'] as const,
};
